<template>
  <b-modal size="xl" class="vh-100" id="ticket-modal">
    <template #modal-title>
      {{ trans('ticket') }} <small>#{{ticket.recipient_id}}</small>
    </template>
    <template v-if="ticket">
      <b-row>
        <b-col class="-12 text-center mb-2">
          <h2>{{ ticket.class_name }}</h2>
          <p v-if="ticket.custom_schedule">{{ ticket.custom_schedule }}</p>
          <p v-else>{{ dateRange }}</p>
          <p v-if="ticket.meta && ticket.meta.extra_info">{{ ticket.meta.extra_info }}</p>
          <p v-if="!noNames">{{ ticket.participant_name }}</p>
        </b-col>
        <b-col class="col-12 text-center align-self-center">
          <img v-if="ticket.qr_code_url" :src="ticket.qr_code_url" alt="QR Code" style="max-width: 100%; max-height: 100%;" />
        </b-col>
      </b-row>
    </template>
  </b-modal>
</template>

<script>
export default {
  props: {
    ticket: {
      type: Object,
      default: null
    }
  },
  data() {
      return {
        trans: trans,
        lang: lang,
      }
    },
  computed: {
    dateRange(){
      return _.timeRangeStr(moment(this.ticket.start), moment(this.ticket.end))
    },
    noNames() {
        return _.get(this.ticket, 'options.do_not_require_names')
      }
  },
  mounted() {
    window.ticketModal = this
  }
}
</script>
